import { buildDemoStudentsForClass } from "./buildDemoStudents";
import { DEMO_TURMA_DISC } from "./buildDemoOccurrences";
import {
  demoGradesV2SessionKey,
  loadDemoGradesV2Session
} from "./demoGradesV2Persistence";

/** Alinhado a buildDemoExamsForTurma (ET1 / P1, P2). */
export const DEMO_COD_ETAPA = "ET1";
export const DEMO_COD_PROVA_P1 = "P1";
export const DEMO_COD_PROVA_P2 = "P2";

export const DEMO_COL_P1 = "demo_p1";
export const DEMO_COL_P2 = "demo_p2";
export const DEMO_COL_MEDIA = "demo_media";
export const DEMO_COL_MEDIA_MAT = "demo_media_mat";
export const DEMO_COL_MEDIA_CI = "demo_media_ci";
export const DEMO_COL_MEDIA_HIST = "demo_media_hist";
export const DEMO_COL_MEDIA_GERAL = "demo_media_geral";

const GROUP_MAIN = "portugues_demo";
const GROUP_OUTRAS = "outras_medias";
const GROUP_CONSOL = "consolidado";

function parseGradeNum(s) {
  if (s == null || s === "") {
    return null;
  }
  const t = String(s).trim().replace(",", ".");
  const n = parseFloat(t);
  return Number.isFinite(n) ? n : null;
}

function formatMedia(n) {
  if (n == null || Number.isNaN(n)) {
    return "";
  }
  const rounded = Math.round(n * 100) / 100;
  return String(rounded).replace(".", ",");
}

function computeMediaFromStrings(p1, p2) {
  const a = parseGradeNum(p1);
  const b = parseGradeNum(p2);
  if (a == null && b == null) {
    return "";
  }
  if (a == null || b == null) {
    return "";
  }
  return formatMedia((a + b) / 2);
}

/** Usado na UI (Notas V2) para atualizar a coluna Média ao editar P1/P2 na demo. */
export function computeDemoMediaFromProvas(p1, p2) {
  return computeMediaFromStrings(p1, p2);
}

/**
 * Média simples das quatro médias de disciplina (PT + três só leitura).
 */
export function computeDemoMediaGeralFromRow(row) {
  const parts = [
    parseGradeNum(row[DEMO_COL_MEDIA]),
    parseGradeNum(row[DEMO_COL_MEDIA_MAT]),
    parseGradeNum(row[DEMO_COL_MEDIA_CI]),
    parseGradeNum(row[DEMO_COL_MEDIA_HIST])
  ];
  if (parts.some(p => p == null)) {
    return "";
  }
  const sum = parts.reduce((a, b) => a + b, 0);
  return formatMedia(sum / 4);
}

function seedOtherMedias(index) {
  const mat = ["7,5", "8", "6,5", "9", "5", "8,5", "7", "6"][
    index % 8
  ];
  const ci = ["8", "7", "5,5", "9", "6", "8", "7,5", "6,5"][index % 8];
  const hist = ["6", "8,5", "7", "8", "6,5", "7,5", "9", "8"][index % 8];
  return { [DEMO_COL_MEDIA_MAT]: mat, [DEMO_COL_MEDIA_CI]: ci, [DEMO_COL_MEDIA_HIST]: hist };
}

/**
 * Períodos (GET ClassDiaryV1/periods).
 */
export function buildDemoGradePeriods(idTurmaDisc) {
  if (String(idTurmaDisc) !== String(DEMO_TURMA_DISC)) {
    return [];
  }
  return [
    {
      id: "1BIM",
      name: "1º bimestre — demonstração",
      formula:
        "Média de Português = (Prova 1 + Prova 2) ÷ 2. Média geral = média aritmética das médias de Português, Matemática, Ciências e História (nesta demonstração, as três últimas são só leitura).",
      currentPeriod: true
    }
  ];
}

/**
 * Tipos de prova (GET …/getSPROVASDefaultData) — lista mínima para o diálogo.
 */
export function buildDemoGradesV2TestTypes() {
  return [
    { id: 1, name: "Prova", editable: true },
    { id: 2, name: "Trabalho", editable: true }
  ];
}

/** Campos complementares (GET …/getSPROVASComplFields) — demo. */
export function buildDemoComplementaryFields() {
  return [
    {
      name: "NIVEL",
      title: "Nível",
      type: "C",
      length: "10",
      editable: true,
      hasLookup: true,
      lookupByCode: true,
      options: [
        { id: "1", label: "Básico" },
        { id: "2", label: "Intermediário" },
        { id: "3", label: "Avançado" }
      ]
    }
  ];
}

function baseColumns(idTurmaDisc) {
  const tid = String(idTurmaDisc);
  return [
    {
      id: DEMO_COL_P1,
      header: "Prova 1",
      group: GROUP_MAIN,
      editable: true,
      order: "1",
      value: "10",
      CODETAPA: DEMO_COD_ETAPA,
      CODPROVA: DEMO_COD_PROVA_P1,
      IDTURMADISC: tid,
      color: "rgba(0,0,0,.5)"
    },
    {
      id: DEMO_COL_P2,
      header: "Prova 2",
      group: GROUP_MAIN,
      editable: true,
      order: "2",
      value: "10",
      CODETAPA: DEMO_COD_ETAPA,
      CODPROVA: DEMO_COD_PROVA_P2,
      IDTURMADISC: tid,
      color: "rgba(0,0,0,.5)"
    },
    {
      id: DEMO_COL_MEDIA,
      header: "Média",
      group: GROUP_MAIN,
      editable: false,
      order: "3",
      value: "10",
      CODETAPA: DEMO_COD_ETAPA,
      CODPROVA: "MEDIA",
      IDTURMADISC: tid,
      color: "rgba(0,80,80,.65)"
    },
    {
      id: DEMO_COL_MEDIA_MAT,
      header: "Média (Mat.)",
      group: GROUP_OUTRAS,
      editable: false,
      order: "4",
      value: "10",
      CODETAPA: DEMO_COD_ETAPA,
      CODPROVA: "MEDIA_MAT",
      IDTURMADISC: tid,
      color: "rgba(0,60,100,.55)"
    },
    {
      id: DEMO_COL_MEDIA_CI,
      header: "Média (Ciên.)",
      group: GROUP_OUTRAS,
      editable: false,
      order: "5",
      value: "10",
      CODETAPA: DEMO_COD_ETAPA,
      CODPROVA: "MEDIA_CI",
      IDTURMADISC: tid,
      color: "rgba(0,60,100,.55)"
    },
    {
      id: DEMO_COL_MEDIA_HIST,
      header: "Média (Hist.)",
      group: GROUP_OUTRAS,
      editable: false,
      order: "6",
      value: "10",
      CODETAPA: DEMO_COD_ETAPA,
      CODPROVA: "MEDIA_HIST",
      IDTURMADISC: tid,
      color: "rgba(0,60,100,.55)"
    },
    {
      id: DEMO_COL_MEDIA_GERAL,
      header: "Média geral",
      group: GROUP_CONSOL,
      editable: false,
      order: "7",
      value: "10",
      CODETAPA: DEMO_COD_ETAPA,
      CODPROVA: "MEDIA_GERAL",
      IDTURMADISC: tid,
      color: "rgba(20,100,80,.7)"
    }
  ];
}

function seedRow(student, index, idTurmaDisc) {
  const p1 = index % 3 === 0 ? "7,5" : "8";
  const p2 = index % 2 === 0 ? "9" : "8,5";
  const media = computeMediaFromStrings(p1, p2);
  const other = seedOtherMedias(index);
  const row = {
    studentId: student.ra,
    id: student.ra,
    idturmadisc: idTurmaDisc,
    name: student.name,
    rollCallNum: index + 1,
    [DEMO_COL_P1]: p1,
    [DEMO_COL_P2]: p2,
    [DEMO_COL_MEDIA]: media,
    ...other
  };
  row[DEMO_COL_MEDIA_GERAL] = computeDemoMediaGeralFromRow(row);
  return row;
}

function applyPersistedOverrides(idTurmaDisc, period, rows) {
  const sessionKey = demoGradesV2SessionKey(idTurmaDisc, period);
  const snap = loadDemoGradesV2Session(sessionKey);
  if (!snap || !snap.byRa) {
    return rows.map(r => {
      const next = { ...r };
      next[DEMO_COL_MEDIA_GERAL] = computeDemoMediaGeralFromRow(next);
      return next;
    });
  }

  const k1 = `${DEMO_COD_ETAPA}-${DEMO_COD_PROVA_P1}`;
  const k2 = `${DEMO_COD_ETAPA}-${DEMO_COD_PROVA_P2}`;

  return rows.map(r => {
    const ra = String(r.studentId);
    const o = snap.byRa[ra];
    if (!o) {
      const next = { ...r };
      next[DEMO_COL_MEDIA_GERAL] = computeDemoMediaGeralFromRow(next);
      return next;
    }
    let p1 = o[k1] != null ? o[k1] : r[DEMO_COL_P1];
    let p2 = o[k2] != null ? o[k2] : r[DEMO_COL_P2];
    if (p1 === " ") {
      p1 = "";
    }
    if (p2 === " ") {
      p2 = "";
    }
    const media = computeMediaFromStrings(p1, p2);
    const next = {
      ...r,
      [DEMO_COL_P1]: p1,
      [DEMO_COL_P2]: p2,
      [DEMO_COL_MEDIA]: media
    };
    next[DEMO_COL_MEDIA_GERAL] = computeDemoMediaGeralFromRow(next);
    return next;
  });
}

/**
 * Grade completa (GET ClassDiaryV1/grades-v2).
 */
export function buildDemoGradesV2Grid(idTurmaDisc, period) {
  if (
    String(idTurmaDisc) !== String(DEMO_TURMA_DISC) ||
    period == null ||
    String(period) !== "1BIM"
  ) {
    return {
      groups: [],
      students: [],
      columns: [],
      testTypes: buildDemoGradesV2TestTypes(),
      complementaryFields: buildDemoComplementaryFields()
    };
  }

  const students = buildDemoStudentsForClass("DEMO-T1");
  const tid = DEMO_TURMA_DISC;
  let rows = students.map((s, i) => seedRow(s, i, tid));
  rows = applyPersistedOverrides(tid, period, rows);

  return {
    groups: [
      { name: "data", header: "Dados dos alunos" },
      { name: GROUP_MAIN, header: "Português — demonstração" },
      { name: GROUP_OUTRAS, header: "Outras disciplinas (só leitura)" },
      { name: GROUP_CONSOL, header: "Consolidado" }
    ],
    students: rows,
    columns: baseColumns(tid),
    testTypes: buildDemoGradesV2TestTypes(),
    complementaryFields: buildDemoComplementaryFields()
  };
}

/**
 * GET ClassDiaryV1/evaluation — resposta mínima para edição de avaliação.
 */
export function buildDemoGradeEvaluation(idTurmaDisc, codEtapa, codProva) {
  if (String(idTurmaDisc) !== String(DEMO_TURMA_DISC)) {
    return {};
  }
  return {
    SProvas: {
      DESCRICAO:
        codProva === DEMO_COD_PROVA_P1
          ? "Prova 1 — demonstração"
          : "Prova 2 — demonstração",
      NUMQUESTOES: "10",
      DISPONIVELALUNOS: "N",
      DISPTODASSUBTURMAS: "N",
      PERMITEENTREGAWEB: "N",
      CODETAPA: codEtapa,
      CODPROVA: codProva
    },
    SProvasCompl: {
      IDTURMADISC: String(idTurmaDisc),
      CODETAPA: codEtapa,
      CODPROVA: codProva,
      TIPOETAPA: "N",
      ATVMOODLE: ""
    }
  };
}
